import { Outlet, useNavigate } from 'react-router-dom';
import { Modal } from "react-bootstrap";

import React, { useState } from 'react'

import { sidebarData } from './Admin_Sidebar'
import DashboardSidebar from '../../layout/Sidebar/Sidebar';


const AdminDashboard = () => {
  const [isexpand, setExpanded] = useState(false);
  return (
    <>
      <div className="dashboard-main-section">
        <DashboardSidebar sidebarData={sidebarData} isexpand={isexpand} setExpanded={setExpanded} />
        <div className={isexpand ? "dashboard-main-content-sectionn" : "dashboard-main-content-sectionnn"}>
          <Outlet />
        </div>
      </div>
    </>
  );
};


export default AdminDashboard
